import { render, staticRenderFns } from "./DepositPage.vue?vue&type=template&id=10f35ea5&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"
import style0 from "./DepositPage.vue?vue&type=style&index=0&id=10f35ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f35ea5",
  null
  
)

export default component.exports